module.exports = __webpack_public_path__ + "static/denture-f60028e22c82fcdfa3924399551397fe.svg";